import { parseISO, startOfYear } from "date-fns";
import { DateValuePair, useBalances } from "@rentablo/api/apiv1";

const calculateIncreaseDecrease = (startValue: number, endValue: number) => {
  if (!endValue || !startValue) return 0;
  if (startValue < 0 && endValue > 0) return 0;
  return endValue / startValue - 1;
};

const balanceAtStartOfYear = (dateValuePairs?: DateValuePair[]) => {
  try {
    if (!dateValuePairs) return 0;

    const start = startOfYear(new Date());
    const match = dateValuePairs
      .slice()
      .reverse()
      .find((dvp) => (dvp.date ? parseISO(dvp.date) < start : false));
    return match?.value ?? 0;
  } catch (err) {
    return 0;
  }
};

export const useCashBalance = (
  accountIds: number[],
  startDate?: Date,
  refetchOnWindowFocus = true
) => {
  const { data, ...rest } = useBalances(
    { id: accountIds, from: startDate?.toISOString() },
    {
      refetchOnWindowFocus,
      enabled: accountIds && accountIds.length > 0,
    }
  );

  const endBalance =
    data?.dateValuePairs[data?.dateValuePairs.length - 1]?.value;
  const startBalance = balanceAtStartOfYear(data?.dateValuePairs);

  const changeYTD =
    endBalance && startBalance
      ? calculateIncreaseDecrease(startBalance, endBalance)
      : 0;

  return {
    changeYTD,
    balance: endBalance,
    chartData: data?.dateValuePairs,
    ...rest,
  };
};
